import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-circle",
  "use": "icon-ic-circle-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-ic-circle\"><rect x=\"1.5\" y=\"1\" width=\"18\" height=\"18\" rx=\"1\" stroke=\"#000\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol